<script>
  import { defineComponent, ref } from 'vue'
  import { useQuasar } from 'quasar'
  import LoadingIndicator from 'components/LoadingIndicator.vue'
  import Logo from "pages/Auth/components/Logo.vue";

  export default defineComponent({
    name: 'Login',
    components: {
      Logo,
      LoadingIndicator
    },
    setup () {
      const $q = useQuasar();
      return {
        qInstance: $q
      }
    },
    data () {
      return {
        username: '',
        submitted: ref(false),
        password: ref(''),
        passwordConfirm: ref(''),
        isPwd: ref(true),
        isPwd2: ref(true)
      }
    },
    created () {
      // reset login status
      this.$store.dispatch('authentication/logout');
    },
    methods: {
      handleSubmit() {
        this.submitted = true;
        const { password, passwordConfirm } = this;
        const { dispatch } = this.$store;
        let userId = this.$route.params.userId
        let hash = this.$route.params.hash

        dispatch('authentication/recover', { password, passwordConfirm, userId, hash });

        setTimeout(() => this.submitted = false, 3000)
      }
    }
  })
</script>

<template>
  <q-page class="app-page-password-reset psw-res justify-center">
    <div class="q-mr-md-xl">
      <form @submit.prevent="handleSubmit" :class="{'disabled': submitted}">
        <div class="q-pa-md">
          <h1>{{ $t('publicPages.passwordReset.headline') }}</h1>
          <p>{{ $t('publicPages.passwordReset.desc') }}</p>
        </div>
        <div class="q-pa-md">
          <div class="app-login-input-wrapper q-gutter">
            <q-input required
                     class="app-login-input-password q-pa-sm"
                     v-model="password"
                     aria-autocomplete="none"
                     :label="$t('publicPages.passwordReset.password')"
                     :title="$t('publicPages.passwordReset.passwordTitle')"
                     :type="isPwd ? 'password' : 'text'"
            >
              <template v-slot:prepend>
                <q-icon class="q-pl-md" name="lock" />
              </template>
              <template v-slot:append>
                <q-icon
                        :name="isPwd ? 'visibility_off' : 'visibility'"
                        class="cursor-pointer"
                        @click="isPwd = !isPwd"
                />
                <q-tooltip anchor="top middle" self="bottom middle" class="app-tooltip-mobile" v-if='$q.platform.is.mobile'>{{ isPwd ? $t('general.showPassword') : $t('general.hidePassword') }}</q-tooltip>
              </template>
            </q-input>
            <q-input required
                     class="app-login-input-password-confirm q-pa-sm"
                     v-model="passwordConfirm"
                     :label="$t('publicPages.passwordReset.passwordConfirm')"
                     :title="$t('publicPages.passwordReset.passwordConfirmTitle')"
                     :type="isPwd2 ? 'password' : 'text'"
            >
              <template v-slot:prepend>
                <q-icon class="q-pl-md" name="lock" />
              </template>
              <template v-slot:append>
                <q-icon
                        :name="isPwd2 ? 'visibility_off' : 'visibility'"
                        class="cursor-pointer"
                        @click="isPwd2 = !isPwd2"
                />
                <q-tooltip anchor="top middle" self="bottom middle" class="app-tooltip-mobile" v-if='$q.platform.is.mobile'>{{ isPwd2 ? $t('general.showPassword') : $t('general.hidePassword') }}</q-tooltip>
              </template>
            </q-input>
          </div>
        </div>
        <div class="q-mt-lg q-pa-md">
          <q-btn
            flat class="app-action-btn"
            :class="{ 'disabled': submitted}"
            :disabled="submitted"
            :label="$t('publicPages.passwordReset.submit')" type="submit" />
        </div>
        <loading-indicator v-if="submitted" wrapper />
      </form>
    </div>
    <logo />
  </q-page>
</template>

<style lang="scss">
  .app-page-password-reset {
    &.disabled {opacity: .3}
    .lds-ring {
      transform: translateX(-50%);
      top: 10rem;
    }
  }
  .app-login-input-wrapper {
    margin: -1.25rem;
  }
  .app-login-input-name, .app-login-input-password, .app-login-input-password-confirm {
    max-width: 400px;
  }
  .psw-res {
    .q-field__control:before,
    .q-field__control:after {
      left: 1rem;
    }
  }
</style>
